// Auto-generated by the set-version.js script.
export const ADMIN_UI_VERSION = '3.6.3';
